import React from 'react'
import './Footer.css'

export const Footer = () => {
  return (
    <div className="note"><a href="https://github.com/Chitransh-j">Made By Chitransh Jawere</a></div>
  )
}
